import React from 'react';
import { Modal, ModalBody, ModalFooter, Button } from 'reactstrap';

const AlertModal = ({ isOpen, toggle, type, message, title }) => {
    const isSuccess = type === 'success';
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalBody className="text-center p-5">
                {isSuccess ? (
                    <i className="mdi mdi-check-circle-outline display-3 text-success mb-4"></i>
                ) : (
                    <i className="mdi mdi-alert-circle-outline display-3 text-danger mb-4"></i>
                )}
                <h4 className="mb-3">{title || (isSuccess ? "Réussite !" : "Échec")}</h4>
                <p className="text-muted font-size-15">{message}</p>
            </ModalBody>
            <ModalFooter className="justify-content-center border-0 pb-4">
                <Button
                    color={isSuccess ? "success" : "danger"}
                    onClick={toggle}
                    className="px-5"
                >
                    D'accord
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default AlertModal;
